import React, { useEffect, useState , useRef } from "react";
import SubIcon1 from "../../image/SubIcon1.svg";
import SubIcon2 from "../../image/SubIcon2.svg";
import SubIcon3 from "../../image/SubIcon3.svg";
import SubIcon4 from "../../image/SubIcon4.svg";
import FormList from "./FormList/FormList";
import { Form, Link, NavLink } from "react-router-dom";
import Setting from "../../image/Setting.svg";
import Alert from "../../image/Alert.svg";
import "./MetricsReport.css";
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  ListItemSecondaryAction,
} from "@mui/material";
import Popup from "reactjs-popup";
import MailIcon from "../../Components/MainIcons/MailIcon";
import { form, selectForm } from "@formio/react";

const MetricsReport = (props) => {
  const divRef = useRef(null);
  const [datamine, Setdatamine] = useState([]);
  const [kurkure, setkurkure] = useState([]);
  const [activeDiv, setActiveDiv] = useState("gov");
  const [formtags, setformtags] = useState([]);
  const [formcount, setformCount] = useState({});

  const handleClick = (tags) => {
    setActiveDiv(tags);
  };

  useEffect(() => {
    if (props.application) {
      myfunc("meta");
    } else {
      myfunc("gov");
    }
  }, [props.application]);

  useEffect(() => {
    const loopForCount = async () => {
      if (!props.application) {
        let formcount = await loopfetchAndStore();
   
        setformCount(formcount);
       
      }
    };

    loopForCount();
 
  }, []);
  
  useEffect(()=>
  {
    if(!props.application && localStorage.getItem("ButtonKey"))
    {
      divRef.current.click();
    }
   

  },[])

  const myfunc = async (tags) => {
    const response = await fetch(`http://localhost:3001/form?tags=${tags}`, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        //   'Content-Type': 'application/json',
        "x-jwt-token": process.env.REACT_APP_X_JWT_TOKEN,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      // body: JSON.stringify(data) // body data type must match "Content-Type" header
    })
      .then((data) => {
        data.json().then((data) => {
          Setdatamine(data);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const loopfetchAndStore = async (tags) => {
    let tagsArr = ["gov", "pla", "peo", "pro"];

    for (let i = 0; i < tagsArr.length; i++) {
      const response = await fetch(
        `http://localhost:3001/form?tags=${tagsArr[i]}`,
        {
          method: "GET", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          // credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            //   'Content-Type': 'application/json',
            "x-jwt-token": process.env.REACT_APP_X_JWT_TOKEN,
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          // body: JSON.stringify(data) // body data type must match "Content-Type" header
        }
      )
        .then((data) => {
          data.json().then((data) => {
            formtags.push(tagsArr[i]);
            formtags.push(data.length);

            if (formtags.length == 8) {
              localStorage.setItem("Countarray", formtags);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // setformCount(formcount)

    return formcount;
  };

  const ButtonItems = [
    {
      icon: (
        <img
          src={SubIcon1}
          className="Page2_Icon1"
          alt="Governance"
          width="38"
        />
      ),
      title: "Pillar 1:",
      name: "Principle of Governance",
      count: 30,
      tags: "gov",
    },
    {
      icon: (
        <img src={SubIcon2} className="Page2_Icon2" alt="Planet" width="38" />
      ),
      title: "Pillar 2:",
      name: "Planet",
      count: 23,
      tags: "pla",
    },
    {
      icon: (
        <img src={SubIcon3} className="Page2_Icon3" alt="People" width="38" />
      ),
      title: "Pillar 3:",
      name: "People",
      count: 16,
      tags: "peo",
    },
    {
      icon: (
        <img
          src={SubIcon4}
          className="Page2_Icon4"
          alt="Prosperity"
          width="38"
        />
      ),
      title: "Pillar 4:",
      name: "Prosperity",
      count: 73,
      tags: "pro",
    },
  ];

  function logout() {
    // props.history.push('/');

    props.state.keycloak.logout();
  }

  (function (timer) {
    window.addEventListener("load", function () {
      var el = document.querySelector(".dataMineData");
      el.addEventListener("scroll", function (e) {
        (function (el) {
          el.classList.add("scroll");
          clearTimeout(timer);
          timer = setTimeout(function () {
            el.classList.remove("scroll");
          }, 100);
        })(el);
      });
    });
  })();

  // const [isActive, setIsActive] = useState(true);
  // const className = isActive ? "active" : "inactive";
  // if(ButtonItems.tags=="gov"){
  //    return className;
  // }

  return (
    <div>
      <div className="EvidenceTaskNavbar">
        <div>
          <span className="EvidenceTitle">Evidence Task</span>
        </div>
        <div>
          <MailIcon state={props.state} />
        </div>
      </div>

      <div className="container-fluid">
        <div className="rows">
          <div className="sidebar-2">
            {props.application ? (
              <></>
            ) : (
              ButtonItems.map((items, index) => {


                return (<>

                 {localStorage.getItem("ButtonKey")==index?<div  ref={divRef}
                    onClick={() => {
                      myfunc(items.tags);
                      handleClick(items.tags);
                      localStorage.setItem("ButtonKey",index)
                    }}
                    className={`div-element ${
                      activeDiv === items.tags ? "Aactive" : "inactive"
                    }`}
                    id="cards"
                    // id="Filter"
                    key={index}
                  >
                  {console.log(index)}
                  {console.log("jiiiiiiiiiii")}
                    <div className="items">
                      <span className="sub1">{items.icon}</span>
                      <div className="HeadingPIllar">
                        <span className="PillarTitle" key={index}>
                          {items.title}
                        </span>
                        <span className="heading"> {items.name}</span>
                        <span className="PillarCount">{}</span>
                      </div>
                    </div>
                  </div>:<div 
                    onClick={() => {
                      myfunc(items.tags);
                      handleClick(items.tags);
                      localStorage.setItem("ButtonKey",index)
                    }}
                    className={`div-element ${
                      activeDiv === items.tags ? "Aactive" : "inactive"
                    }`}
                    id="cards"
                    // id="Filter"
                    key={index}
                  >
                    <div className="items">
                      <span className="sub1">{items.icon}</span>
                      <div className="HeadingPIllar">
                        <span className="PillarTitle" key={index}>
                          {items.title}
                        </span>
                        <span className="heading"> {items.name}</span>
                        <span className="PillarCount">{}</span>
                      </div>
                    </div>
                  </div>} 
                  </> );
              })
            )}
          </div>
          <div className="container-fluid dataMineData">
            <div className="total">Total: {datamine.length} </div>
            {datamine.map((dataout) => {
              let route;

              if (props.application) {
                route = `/applications/${dataout._id}`;
              } else {
                route = `/forms/${dataout._id}`;
              }

              return (
                <>
                  <div>
                    <div>
                      <NavLink to={route} style={{ textDecoration: "none" }}>
                        <FormList data={dataout.title} id={dataout._id} />
                      </NavLink>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricsReport;
